/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitLogoExtensionEnum } from './PressKitLogoExtensionEnum';
import {
    PressKitLogoExtensionEnumFromJSON,
    PressKitLogoExtensionEnumFromJSONTyped,
    PressKitLogoExtensionEnumToJSON,
} from './PressKitLogoExtensionEnum';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';

/**
 * 
 * @export
 * @interface PostPressKitBodyLogosInner
 */
export interface PostPressKitBodyLogosInner {
    /**
     * エラー箇所を特定するために必要な各オブジェクトのID
     * @type {string}
     * @memberof PostPressKitBodyLogosInner
     */
    objectId: string;
    /**
     * 既存ロゴのUUID。空文字だと新規作成される。
     * @type {string}
     * @memberof PostPressKitBodyLogosInner
     */
    id?: string;
    /**
     * S3へのURI、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PostPressKitBodyLogosInner
     */
    resourceUri: string;
    /**
     * 
     * @type {PressKitLogoExtensionEnum}
     * @memberof PostPressKitBodyLogosInner
     */
    extension: PressKitLogoExtensionEnum;
    /**
     * ラスター画像の幅。単位はpx。ベクター画像は不要。resource_uri変更時だけ変更可能。
     * @type {number}
     * @memberof PostPressKitBodyLogosInner
     */
    width?: number;
    /**
     * ラスター画像の高さ。単位はpx。ベクター画像は不要。resource_uri変更時だけ変更可能。
     * @type {number}
     * @memberof PostPressKitBodyLogosInner
     */
    height?: number;
    /**
     * ファイルのサイズ（単位はbytes）。resource_uri変更時だけ変更可能。
     * @type {number}
     * @memberof PostPressKitBodyLogosInner
     */
    fileSize: number;
    /**
     * アップロードされたファイルの名前。resource_uri変更時だけ変更可能。
     * @type {string}
     * @memberof PostPressKitBodyLogosInner
     */
    filename: string;
    /**
     * キャプションとして使われるファイルの名前。設定されなければfilenameが使われる。
     * @type {string}
     * @memberof PostPressKitBodyLogosInner
     */
    title?: string;
    /**
     * 企業が登録したファイルの説明文
     * @type {string}
     * @memberof PostPressKitBodyLogosInner
     */
    description?: string;
    /**
     * 
     * @type {Array<PressKitTag>}
     * @memberof PostPressKitBodyLogosInner
     */
    tags: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PostPressKitBodyLogosInner interface.
 */
export function instanceOfPostPressKitBodyLogosInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectId" in value;
    isInstance = isInstance && "resourceUri" in value;
    isInstance = isInstance && "extension" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PostPressKitBodyLogosInnerFromJSON(json: any): PostPressKitBodyLogosInner {
    return PostPressKitBodyLogosInnerFromJSONTyped(json, false);
}

export function PostPressKitBodyLogosInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBodyLogosInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectId': json['__object_id'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'resourceUri': json['resource_uri'],
        'extension': PressKitLogoExtensionEnumFromJSON(json['extension']),
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'fileSize': json['file_size'],
        'filename': json['filename'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PostPressKitBodyLogosInnerToJSON(value?: PostPressKitBodyLogosInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '__object_id': value.objectId,
        'id': value.id,
        'resource_uri': value.resourceUri,
        'extension': PressKitLogoExtensionEnumToJSON(value.extension),
        'width': value.width,
        'height': value.height,
        'file_size': value.fileSize,
        'filename': value.filename,
        'title': value.title,
        'description': value.description,
        'tags': ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

